import { render, staticRenderFns } from "./RuleStoreEquivalence.vue?vue&type=template&id=f8af5f8c&scoped=true&"
import script from "./RuleStoreEquivalence.vue?vue&type=script&lang=js&"
export * from "./RuleStoreEquivalence.vue?vue&type=script&lang=js&"
import style0 from "./RuleStoreEquivalence.vue?vue&type=style&index=0&id=f8af5f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8af5f8c",
  null
  
)

export default component.exports